import { useParams, useSearchParams } from "react-router";
import {
  SOFTWARE_CATALOG_ARCHITECTURE_PARAM,
  SOFTWARE_CATALOG_EXTENSION_PARAM,
  SOFTWARE_CATALOG_NO_EXTENSION,
} from "Constants";

export type CatalogParams = {
  groupId: string | undefined;
  catalogId: string | undefined;
  platform: string | undefined;
  packageId: string | undefined;
  architecture: string | null;
  extension: string | null;
};

export const useCatalogParams = (): CatalogParams => {
  const { groupId, catalogId, platform, packageId } = useParams();
  const [searchParams] = useSearchParams();
  const extension = searchParams.get(SOFTWARE_CATALOG_EXTENSION_PARAM);

  return {
    groupId,
    catalogId,
    platform,
    packageId,
    architecture: searchParams.get(SOFTWARE_CATALOG_ARCHITECTURE_PARAM),
    extension: extension === SOFTWARE_CATALOG_NO_EXTENSION ? "" : extension,
  };
};

export default useCatalogParams;
